/**
 * Derivación PURA de los parámetros de fecha que CierreCaja.js envía a la
 * API, a partir del periodo seleccionado. Deliberadamente no calcula
 * "hoy"/"ayer"/"esta semana" aquí: esas fechas dependen de la zona horaria
 * operativa (America/Mexico_City) y esa resolución vive exclusivamente en
 * el backend (ver backend/src/config/fechas.js y
 * backend/src/services/cierreCajaService.js::resolverFechasCierre). El
 * cliente solo manda el preset elegido; para DIA_ESPECIFICO/
 * RANGO_PERSONALIZADO manda además la fecha explícita que el usuario
 * escribió.
 *
 * Mantener esta función pura y sin dependencias de React permite probarla
 * con Node liso (ver cierreCajaPeriodo.test.mjs), sin levantar un DOM ni
 * depender de @testing-library (no instalada en este proyecto).
 */

export function calcularParametrosPeriodo(periodoPreset, { fechaEspecifica = '', rangoPersonalizado = { desde: '', hasta: '' } } = {}) {
  switch (periodoPreset) {
    case 'DIA_ESPECIFICO':
      return { fecha: fechaEspecifica || undefined };
    case 'RANGO_PERSONALIZADO':
      return {
        fechaDesde: rangoPersonalizado.desde || undefined,
        fechaHasta: rangoPersonalizado.hasta || undefined
      };
    case 'HOY':
    case 'AYER':
    case 'ESTA_SEMANA':
      return {};
    default:
      return {};
  }
}
